'use client';

import React, { useState } from 'react';
import { Eye, Truck, MessageSquare, RotateCcw, AlertCircle, ChevronUp, ChevronDown, ChevronsUpDown, ShoppingCart } from 'lucide-react';
import type { Order, OrderStatus } from './OrderManagementContent';

// Backend integration: GET /api/seller/orders?status=...&page=...&search=...
const allOrders: Order[] = [
{
  id: 'ord-20260510-1842',
  customer: 'Bilal Hussain',
  customerCity: 'Lahore',
  customerPhone: '+92 300 1234567',
  customerEmail: 'bilal.h@gmail.com',
  productCount: 2,
  date: '10 May 2026, 09:44',
  amount: 107999,
  payment: 'Online',
  status: 'pending',
  fba: false,
  trackingNumber: null,
  shippingAddress: 'House 12, Block D, Model Town, Lahore, Punjab',
  items: [
  { name: 'Samsung Galaxy A55 5G 8GB/256GB', sku: 'SAM-A55-256-BLK', qty: 1, price: 89999, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2e6e219-1772429765169.png", imageAlt: 'Samsung Galaxy A55 smartphone' },
  { name: 'Logitech MX Master 3S Mouse', sku: 'LOG-MXM3S-GR-WL', qty: 1, price: 18000, image: "https://images.unsplash.com/photo-1615734986403-ff1bf12d14ff", imageAlt: 'Logitech wireless mouse' }],

  timeline: [
  { event: 'Order Placed', time: '10 May 2026, 09:44', done: true },
  { event: 'Payment Confirmed', time: '10 May 2026, 09:45', done: true },
  { event: 'Seller Accepted', time: 'Pending', done: false },
  { event: 'Shipped', time: '—', done: false },
  { event: 'Delivered', time: '—', done: false }]

},
{
  id: 'ord-20260510-1831',
  customer: 'Zara Malik',
  customerCity: 'Karachi',
  customerPhone: '+92 321 9876543',
  customerEmail: 'zara.malik@yahoo.com',
  productCount: 1,
  date: '10 May 2026, 09:12',
  amount: 18500,
  payment: 'COD',
  status: 'processing',
  fba: false,
  trackingNumber: null,
  shippingAddress: 'Flat 5B, Clifton Block 4, Karachi, Sindh',
  items: [
  { name: 'Logitech MX Master 3S Mouse', sku: 'LOG-MXM3S-GR-WL', qty: 1, price: 18500, image: "https://images.unsplash.com/photo-1615734986403-ff1bf12d14ff", imageAlt: 'Logitech wireless mouse gray' }],

  timeline: [
  { event: 'Order Placed', time: '10 May 2026, 09:12', done: true },
  { event: 'COD Order Confirmed', time: '10 May 2026, 09:13', done: true },
  { event: 'Processing Started', time: '10 May 2026, 09:44', done: true },
  { event: 'Shipped', time: '—', done: false },
  { event: 'Delivered', time: '—', done: false }]

},
{
  id: 'ord-20260510-1819',
  customer: 'Usman Tariq',
  customerCity: 'Islamabad',
  customerPhone: '+92 333 5551234',
  customerEmail: 'usman.tariq@hotmail.com',
  productCount: 3,
  date: '10 May 2026, 08:55',
  amount: 231000,
  payment: 'Online',
  status: 'processing',
  fba: true,
  trackingNumber: null,
  shippingAddress: 'Street 12, F-7/2, Islamabad, ICT',
  items: [
  { name: 'HP Victus 15 Gaming Laptop', sku: 'HP-VIC-15-I5-8G', qty: 1, price: 185000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ef3d81d-1777043255349.png", imageAlt: 'HP gaming laptop' },
  { name: 'Logitech MX Master 3S Mouse', sku: 'LOG-MXM3S-GR-WL', qty: 1, price: 18500, image: "https://images.unsplash.com/photo-1615734986403-ff1bf12d14ff", imageAlt: 'Logitech wireless mouse' },
  { name: 'Corsair K95 RGB Keyboard', sku: 'COR-K95-RGB-PLT', qty: 1, price: 27500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_17b673cd0-1772058626912.png", imageAlt: 'Corsair RGB mechanical keyboard' }],

  timeline: [
  { event: 'Order Placed', time: '10 May 2026, 08:55', done: true },
  { event: 'Payment Confirmed', time: '10 May 2026, 08:56', done: true },
  { event: 'FBA Processing', time: '10 May 2026, 09:00', done: true },
  { event: 'Shipped from FC', time: '—', done: false },
  { event: 'Delivered', time: '—', done: false }]

},
{
  id: 'ord-20260510-1802',
  customer: 'Sana Iqbal',
  customerCity: 'Faisalabad',
  customerPhone: '+92 311 7778888',
  customerEmail: 'sana.iqbal@gmail.com',
  productCount: 1,
  date: '10 May 2026, 08:22',
  amount: 89999,
  payment: 'Online',
  status: 'shipped',
  fba: true,
  trackingNumber: 'TCS-PKR-20260510-88421',
  shippingAddress: 'House 44, Peoples Colony No.1, Faisalabad, Punjab',
  items: [
  { name: 'Samsung Galaxy A55 5G 8GB/256GB', sku: 'SAM-A55-256-BLK', qty: 1, price: 89999, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2e6e219-1772429765169.png", imageAlt: 'Samsung Galaxy A55 smartphone' }],

  timeline: [
  { event: 'Order Placed', time: '10 May 2026, 08:22', done: true },
  { event: 'Payment Confirmed', time: '10 May 2026, 08:23', done: true },
  { event: 'FBA Dispatched', time: '10 May 2026, 10:30', done: true },
  { event: 'In Transit (TCS)', time: '10 May 2026, 14:00', done: true },
  { event: 'Delivered', time: '—', done: false }]

},
{
  id: 'ord-20260509-1791',
  customer: 'Kamran Shah',
  customerCity: 'Multan',
  customerPhone: '+92 344 2223333',
  customerEmail: 'kamran.shah@outlook.com',
  productCount: 2,
  date: '09 May 2026, 22:41',
  amount: 37000,
  payment: 'COD',
  status: 'shipped',
  fba: false,
  trackingNumber: 'LCS-2026-0509-44211',
  shippingAddress: 'Near Hussain Agahi Chowk, Gulgasht Colony, Multan, Punjab',
  items: [
  { name: 'JBL Charge 5 Speaker Black', sku: 'JBL-CHG5-BLK-PK', qty: 1, price: 25000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_116019093-1765274487348.png", imageAlt: 'JBL portable bluetooth speaker' },
  { name: 'Anker PowerCore 20000mAh', sku: 'ANK-PC20K-BK', qty: 1, price: 12000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_147500398-1772732181554.png", imageAlt: 'Anker portable power bank' }],

  timeline: [
  { event: 'Order Placed', time: '09 May 2026, 22:41', done: true },
  { event: 'COD Confirmed', time: '09 May 2026, 22:42', done: true },
  { event: 'Packed & Ready', time: '10 May 2026, 09:00', done: true },
  { event: 'Picked Up by Leopard', time: '10 May 2026, 11:30', done: true },
  { event: 'Delivered', time: '—', done: false }]

},
{
  id: 'ord-20260509-1778',
  customer: 'Ayesha Raza',
  customerCity: 'Rawalpindi',
  customerPhone: '+92 300 9991111',
  customerEmail: 'ayesha.raza@gmail.com',
  productCount: 1,
  date: '09 May 2026, 19:30',
  amount: 62000,
  payment: 'Online',
  status: 'delivered',
  fba: false,
  trackingNumber: 'TCS-PKR-20260507-71188',
  shippingAddress: 'Bahria Town Phase 7, Rawalpindi, Punjab',
  items: [
  { name: 'Sony WH-1000XM5 Headphones', sku: 'SNY-WH-XM5-BK', qty: 1, price: 62000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e8b37f6f-1773111581386.png", imageAlt: 'Sony noise cancelling headphones' }],

  timeline: [
  { event: 'Order Placed', time: '07 May 2026, 14:22', done: true },
  { event: 'Payment Confirmed', time: '07 May 2026, 14:23', done: true },
  { event: 'Shipped (TCS)', time: '08 May 2026, 10:00', done: true },
  { event: 'Out for Delivery', time: '09 May 2026, 09:30', done: true },
  { event: 'Delivered', time: '09 May 2026, 19:30', done: true }]

},
{
  id: 'ord-20260509-1765',
  customer: 'Hassan Mirza',
  customerCity: 'Lahore',
  customerPhone: '+92 322 4445556',
  customerEmail: 'hassan.mirza@gmail.com',
  productCount: 4,
  date: '09 May 2026, 16:18',
  amount: 358000,
  payment: 'Online',
  status: 'delivered',
  fba: true,
  trackingNumber: 'FBA-KHI-20260506-33291',
  shippingAddress: 'DHA Phase 5, Lahore, Punjab',
  items: [
  { name: 'HP Victus 15 Gaming Laptop', sku: 'HP-VIC-15-I5-8G', qty: 1, price: 185000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ef3d81d-1777043255349.png", imageAlt: 'HP gaming laptop' },
  { name: 'Dell 27" 4K Monitor', sku: 'DEL-P2723QE-BK', qty: 1, price: 94000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1036d668a-1772401577033.png", imageAlt: 'Dell 4K monitor' },
  { name: 'Logitech MX Master 3S', sku: 'LOG-MXM3S-GR-WL', qty: 1, price: 18500, image: "https://images.unsplash.com/photo-1615734986403-ff1bf12d14ff", imageAlt: 'Logitech wireless mouse' },
  { name: 'Corsair K95 RGB Keyboard', sku: 'COR-K95-RGB-PLT', qty: 1, price: 60500, image: "https://images.unsplash.com/photo-1639832824113-bb07858b709b", imageAlt: 'Corsair keyboard' }],

  timeline: [
  { event: 'Order Placed', time: '06 May 2026, 11:00', done: true },
  { event: 'Payment Confirmed', time: '06 May 2026, 11:01', done: true },
  { event: 'FBA Dispatched', time: '07 May 2026, 08:00', done: true },
  { event: 'In Transit', time: '08 May 2026, 06:00', done: true },
  { event: 'Delivered', time: '09 May 2026, 16:18', done: true }]

},
{
  id: 'ord-20260509-1754',
  customer: 'Nadia Farooq',
  customerCity: 'Karachi',
  customerPhone: '+92 315 6667778',
  customerEmail: 'nadia.farooq@yahoo.com',
  productCount: 1,
  date: '09 May 2026, 14:05',
  amount: 124500,
  payment: 'COD',
  status: 'cancelled',
  fba: false,
  trackingNumber: null,
  shippingAddress: 'North Nazimabad Block H, Karachi, Sindh',
  items: [
  { name: 'Haier 1.5 Ton Inverter AC', sku: 'HAI-AC-18T-WHT', qty: 1, price: 124500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_15129fceb-1774025968005.png", imageAlt: 'Haier air conditioner' }],

  timeline: [
  { event: 'Order Placed', time: '09 May 2026, 14:05', done: true },
  { event: 'COD Pending', time: '09 May 2026, 14:06', done: true },
  { event: 'Cancelled by Customer', time: '09 May 2026, 15:30', done: true },
  { event: 'Refund Initiated', time: 'N/A (COD)', done: true }]

},
{
  id: 'ord-20260509-1741',
  customer: 'Imran Baig',
  customerCity: 'Sialkot',
  customerPhone: '+92 301 3334445',
  customerEmail: 'imran.baig@gmail.com',
  productCount: 2,
  date: '09 May 2026, 11:44',
  amount: 44000,
  payment: 'Online',
  status: 'return',
  fba: false,
  trackingNumber: 'TCS-PKR-20260503-55991',
  shippingAddress: 'Allama Iqbal Town, Sialkot, Punjab',
  items: [
  { name: 'JBL Charge 5 Speaker', sku: 'JBL-CHG5-BLK-PK', qty: 1, price: 25000, image: "https://images.unsplash.com/photo-1623732900752-75cb69c5963a", imageAlt: 'JBL portable speaker' },
  { name: 'Anker PowerCore 20000mAh', sku: 'ANK-PC20K-BK', qty: 1, price: 19000, image: "https://images.unsplash.com/photo-1564286027156-9ad736dfbbbb", imageAlt: 'Anker power bank' }],

  timeline: [
  { event: 'Delivered', time: '05 May 2026, 14:00', done: true },
  { event: 'Return Requested', time: '07 May 2026, 10:22', done: true },
  { event: 'Return Approved', time: '08 May 2026, 09:00', done: true },
  { event: 'Return Picked Up', time: '09 May 2026, 11:44', done: true },
  { event: 'Refund Processed', time: '—', done: false }]

},
{
  id: 'ord-20260508-1728',
  customer: 'Fatima Zaidi',
  customerCity: 'Lahore',
  customerPhone: '+92 310 8889990',
  customerEmail: 'fatima.zaidi@gmail.com',
  productCount: 1,
  date: '08 May 2026, 09:22',
  amount: 18500,
  payment: 'Online',
  status: 'dispute',
  fba: false,
  trackingNumber: 'LCS-2026-0504-11223',
  shippingAddress: 'Johar Town Phase 2, Lahore, Punjab',
  items: [
  { name: 'Logitech MX Master 3S Mouse', sku: 'LOG-MXM3S-GR-WL', qty: 1, price: 18500, image: "https://images.unsplash.com/photo-1615734986403-ff1bf12d14ff", imageAlt: 'Logitech wireless mouse' }],

  timeline: [
  { event: 'Delivered', time: '06 May 2026, 18:00', done: true },
  { event: 'Dispute Opened', time: '08 May 2026, 09:22', done: true },
  { event: 'Seller Response Due', time: '10 May 2026, 09:22', done: false },
  { event: 'Admin Review', time: '—', done: false }]

}];


type SortKey = 'date' | 'amount' | 'customer';
type SortDir = 'asc' | 'desc';

const statusMap: Record<string, React.ReactNode> = {
  pending: <span className="status-pending">Pending</span>,
  processing: <span className="status-processing">Processing</span>,
  shipped: <span className="status-shipped">Shipped</span>,
  delivered: <span className="status-delivered">Delivered</span>,
  cancelled: <span className="status-cancelled">Cancelled</span>,
  return: <span className="status-return">Return</span>,
  dispute: <span className="status-dispute">Dispute</span>
};

interface OrderTableProps {
  activeStatus: OrderStatus;
  filters: {search: string;dateFrom: string;dateTo: string;minAmount: string;maxAmount: string;};
  selectedIds: string[];
  onSelectIds: (ids: string[]) => void;
  onSelectOrder: (order: Order) => void;
  selectedOrderId: string | null;
}

export default function OrderTable({
  activeStatus,
  filters,
  selectedIds,
  onSelectIds,
  onSelectOrder,
  selectedOrderId
}: OrderTableProps) {
  const [sortKey, setSortKey] = useState<SortKey>('date');
  const [sortDir, setSortDir] = useState<SortDir>('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const handleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir((d) => d === 'asc' ? 'desc' : 'asc');else
    {setSortKey(key);setSortDir('desc');}
  };

  const filtered = allOrders.filter((o) => {
    if (activeStatus !== 'all' && o.status !== activeStatus) return false;
    const q = filters.search.toLowerCase();
    if (q && !o.id.toLowerCase().includes(q) && !o.customer.toLowerCase().includes(q)) return false;
    if (filters.minAmount && o.amount < Number(filters.minAmount)) return false;
    if (filters.maxAmount && o.amount > Number(filters.maxAmount)) return false;
    return true;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sortKey === 'amount') return sortDir === 'asc' ? a.amount - b.amount : b.amount - a.amount;
    if (sortKey === 'customer') return sortDir === 'asc' ? a.customer.localeCompare(b.customer) : b.customer.localeCompare(a.customer);
    return sortDir === 'asc' ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date);
  });

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const paginated = sorted.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const allSelected = paginated.length > 0 && paginated.every((o) => selectedIds.includes(o.id));

  const SortIcon = ({ col }: {col: SortKey;}) => {
    if (sortKey !== col) return <ChevronsUpDown size={12} className="text-muted-foreground/50" />;
    return sortDir === 'asc' ? <ChevronUp size={12} className="text-primary" /> : <ChevronDown size={12} className="text-primary" />;
  };

  return (
    <div className="card overflow-hidden">
      <div className="overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm min-w-[820px]">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-10 px-4 py-3">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={() =>
                  allSelected ? onSelectIds([]) : onSelectIds(paginated.map((o) => o.id))
                  }
                  className="w-4 h-4 rounded border-border accent-primary cursor-pointer" />
                
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">Order #</th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('customer')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Customer <SortIcon col="customer" />
                </button>
              </th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-muted-foreground">Items</th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('date')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Date <SortIcon col="date" />
                </button>
              </th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('amount')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Amount <SortIcon col="amount" />
                </button>
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">Payment</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">Status</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-muted-foreground">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginated.length === 0 &&
            <tr>
                <td colSpan={9} className="py-16 text-center">
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
                      <ShoppingCart size={20} className="text-muted-foreground" />
                    </div>
                    <p className="text-sm font-semibold">No orders found</p>
                    <p className="text-xs text-muted-foreground">Try adjusting your filters or selecting a different status tab</p>
                  </div>
                </td>
              </tr>
            }
            {paginated.map((order) => {
              const isSelected = selectedIds.includes(order.id);
              const isActive = selectedOrderId === order.id;

              return (
                <tr
                  key={order.id}
                  onClick={() => onSelectOrder(order)}
                  className={`table-row-hover border-b border-border/50 last:border-0 group cursor-pointer ${
                  isActive ? 'bg-secondary/40 border-l-2 border-l-primary' : isSelected ? 'bg-secondary/20' : ''}`
                  }>
                  
                  {/* Checkbox */}
                  <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() =>
                      onSelectIds(
                        isSelected ? selectedIds.filter((i) => i !== order.id) : [...selectedIds, order.id]
                      )
                      }
                      className="w-4 h-4 rounded border-border accent-primary cursor-pointer" />
                    
                  </td>

                  {/* Order # */}
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1.5">
                      <code className="text-xs font-mono text-primary font-semibold">{order.id}</code>
                      {order.fba &&
                      <span className="text-2xs bg-primary text-white px-1 py-0.5 rounded font-bold">FBA</span>
                      }
                    </div>
                  </td>

                  {/* Customer */}
                  <td className="px-4 py-3">
                    <p className="text-xs font-semibold text-foreground">{order.customer}</p>
                    <p className="text-2xs text-muted-foreground">{order.customerCity}</p>
                  </td>

                  {/* Items */}
                  <td className="px-4 py-3 text-center">
                    <span className="bg-muted text-muted-foreground px-2 py-0.5 rounded-full text-xs font-medium">
                      {order.productCount}
                    </span>
                  </td>

                  {/* Date */}
                  <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{order.date}</td>

                  {/* Amount */}
                  <td className="px-4 py-3 text-xs font-bold tabular-nums whitespace-nowrap">
                    PKR {order.amount.toLocaleString('en-PK')}
                  </td>

                  {/* Payment */}
                  <td className="px-4 py-3">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                    order.payment === 'COD' ? 'bg-orange-50 text-orange-700' :
                    order.payment === 'Wallet' ? 'bg-purple-50 text-purple-700' : 'bg-blue-50 text-blue-700'}`
                    }>
                      {order.payment}
                    </span>
                  </td>

                  {/* Status */}
                  <td className="px-4 py-3">{statusMap[order.status]}</td>

                  {/* Actions */}
                  <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                    <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                      <button
                        onClick={() => onSelectOrder(order)}
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-primary"
                        title="View order details">
                        
                        <Eye size={14} />
                      </button>
                      {order.status === 'processing' &&
                      <button
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-success"
                        title="Mark as shipped — add tracking number">
                        
                          <Truck size={14} />
                        </button>
                      }
                      {order.status === 'dispute' &&
                      <button
                        className="p-1.5 rounded-lg hover:bg-danger/10 transition-colors text-muted-foreground hover:text-danger"
                        title="Respond to dispute — required within 48h">
                        
                          <AlertCircle size={14} />
                        </button>
                      }
                      {order.status === 'return' &&
                      <button
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-orange-600"
                        title="Process return">
                        
                          <RotateCcw size={14} />
                        </button>
                      }
                      <button
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-blue-600"
                        title="Message customer">
                        
                        <MessageSquare size={14} />
                      </button>
                    </div>
                  </td>
                </tr>);

            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-border bg-muted/20">
        <span className="text-xs text-muted-foreground">
          {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, sorted.length)} of {sorted.length} orders
        </span>
        <div className="flex items-center gap-1">
          <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">«</button>
          <button onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={currentPage === 1} className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">‹</button>
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            const start = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
            const page = start + i;
            return (
              <button
                key={`ord-page-${page}`}
                onClick={() => setCurrentPage(page)}
                className={`w-7 h-7 rounded-lg text-xs font-medium transition-colors ${
                page === currentPage ? 'bg-primary text-white' : 'btn-ghost'}`
                }>
                
                {page}
              </button>);

          })}
          <button onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">›</button>
          <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">»</button>
        </div>
      </div>
    </div>);

}